import React from 'react';
import './scss/app.css';
import 'react-select-plus/dist/react-select-plus.css';
import MainPanel from './views/main-panel/MainPanel';
import Notifications from 'react-notify-toast';
import Navbar from './components/navbar/Navbar';
import ComponentHelper from './supers/ComponentHelper';
import RoutingService from './services/RoutingService';
import NotificationSystem from 'react-notification-system';
const RS = new RoutingService();

class App extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			navItems: []
		};
		let startingLocation = this.props.history.location.pathname;
		this._notificationSystem = null;
		RS.setHistory(this.props.history);
		RS.setLastLocation(startingLocation);
	}

	componentDidMount() {
		const { history } = this.props;
		this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
		this.handleLocationChange(history.location);
		this._notificationSystem = this.refs.notificationSystem;
		RS.setNotificationSystem(this._notificationSystem);
	}

	componentWillUnmount() {
		if (this.unsubscribeFromHistory) {
			this.unsubscribeFromHistory();
		}
	}

	handleLocationChange = location => {
		let path = location.pathname;
		let items = RS.getCurrentNavItems(path);
		this.observe(() => {
			this.data.navItems = items;
		});
		RS.setLastLocation(path);
	};

	render() {
		return (
			<div className="app hbox">
				<MainPanel />
				<Navbar navItems={this.data.navItems} tenant={RS.getCurrentTenant()} application={RS.getCurrentApplication()} />
				<Notifications />
				<NotificationSystem ref="notificationSystem" />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js